import React from 'react';

/**
 * Search box state: local text so typing stays smooth and only *commits* (triggers a query)
 * on Enter or when cleared — but still controlled by `value`, so "Limpiar" (which resets
 * filters.search to '') empties the field. A plain uncontrolled input wouldn't clear.
 */
export function useCommittedSearch(value, onCommit) {
    const [text, setText] = React.useState(value || '');
    React.useEffect(() => {
        setText(value || '');
    }, [value]);

    const onChange = (e) => {
        setText(e.target.value);
        // Clearing the box applies immediately; typing waits for Enter.
        if (!e.target.value) onCommit('');
    };
    const onPressEnter = (e) => onCommit(e.target.value);

    return { text, onChange, onPressEnter };
}
